<div mat-dialog-content>
    <div class="user-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genUserNew (closeDialog)="onClose()" [personId]="personId"></app-genUserNew>
</div>